import Base from './Base'

export default class Catalog extends Base {
    type = 'catalog';
  
    toJSON = () => {
        return { 'type': this.type, 'items': this.items }
    }
}